<template lang="pug">
  .sud-block-overlay.week__panel
    .month-dates__control
      .month-dates__control-month {{ period.type.name }}
      //- .month-dates__control-item(@click="subtractWeek")
      .month-dates__control-item(@click="loadEventsForPrevPeriod")
        v-icon(color="#FFFFFF" small) chevron_left
        | Предыдущая неделя
      //- .month-dates__control-item(@click="addWeek")
      .month-dates__control-item(@click="loadEventsForNextPeriod")
        | Следующая неделя
        v-icon(color="#FFFFFF" small) chevron_right
    
    v-layout
      //- v-flex(v-for="(day, index) in periodDates" :key="index" :class="[selectedDate === day ? 'item-wide' : 'item-normal']" @click="selectedDate = day")
      v-flex(
        v-for="(day, index) in periodDates"
        :key="index"
        :class="[selectedDate === day ? 'item-wide' : 'item-normal']"
        @click="selectDate(day)"
      )
        .week__weekdays-wrapper
          .week__weekdays-day(:class="{ 'week__weekdays-day--selected': selectedDate === day }")
            .week__weekdays-date {{ dayOfMonth(day) }}
            .week__weekdays-title {{ dayName(index, day) }}
          .week__day-hours
            calendar-week-day(:date="day" :selected="selectedDate === day" @select="$emit('select', $event)")
</template>

<script>
import moment from 'moment'
import CalendarWeekDay from "./CalendarWeekDay"
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'

moment.locale('ru')

const weekdays = ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'воскресенье']
const shortWeekdays = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс']

export default {
  components: {
    CalendarWeekDay
  },

  computed: {
    ...mapState('event', ['period', 'selectedDate']),
    ...mapGetters('event', ['periodDates']),
  },

  methods: {
    ...mapMutations('event', ['setPeriodDate', 'selectDate']),
    ...mapActions('event', ['loadEventsForPrevPeriod', 'loadEventsForNextPeriod']),

    isToday (day) {
      return moment().isSame(day, 'day')
    },

    dayOfMonth (day) {
      return moment(day).date()
    },

    dayName (dayNumber, day) {
      return this.selectedDate === day ? weekdays[dayNumber] : shortWeekdays[dayNumber]
    },

    // addWeek () {
    //   this.updateEvents( moment(this.periodDate).startOf('week').add(7, 'day') )
    // },

    // subtractWeek () {
    //   this.updateEvents( moment(this.periodDate).startOf('week').subtract(7, 'day') )
    // },

    // updateEvents (date) {
    //   this.setPeriodDate( moment(date) )
    //   // this.$store.dispatch('event/LOAD_EVENTS', { from: date.startOf('week').format('YYYY-MM-DD'), to: date.endOf('week').add(1, 'day').format('YYYY-MM-DD') })
    // }
  }
}
</script>

<style lang="scss" scoped>
.month-dates__control {
  position: relative;
  text-align: right;
  // padding: 11px 16px;
  height: 44px;

  &-month {
    position: absolute;
    top: 0px;
    left: 0px;

    font-family: Roboto Slab;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 18px;

    color: #C4C4C4;

    opacity: 0.6;
  }

  &-item {
    display: inline-block;
    height: 18px;
    margin-left: 60px;

    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    /* identical to box height, or 129% */

    color: #959595;
    cursor: pointer;
  }
}
.week__panel {
  padding: 11px 16px;
}
.week {
  display: flex;
  flex-direction: row;
}
.week__weekdays {
  table-layout: fixed ;
  width: 100%;
  margin: 0 8px;
  border-spacing: 8px;
}
.item-normal {
  flex: 1 1;
}
.item-wide {
  flex: 3 1;
}
.week__weekdays-wrapper {
  padding: 0 4px;
}
.week__weekdays-day {
  border-radius: 5px 5px 0px 0px;
  height: 60px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  // border: 1px solid lightgray;
  padding: 14px 11px 12px 16px;
  width: 100%;

  background: #F0F0F0;
  color: #757575;

  &--selected {
    background-color: #1B93AD;
    color: #FFFFFF;
  }
}
.week__weekdays-date {
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 32px;
}
.week__weekdays-title {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
}
</style>
